import { Modal, Row, Col } from "antd";
import momentTZ from "moment-timezone";
import React, { Component } from "react";

const RowForm = props => (
  <Row style={{ padding: "5px 10px" }}>{props.children}</Row>
);

class ModalDetail extends Component {
  render() {
    let { priceCheck, toggleModalDetail, showModalDetail } = this.props;
    return priceCheck && priceCheck.id ? (
      <Modal
        title="Detail Cek Harga"
        visible={showModalDetail}
        onOk={() => toggleModalDetail(false)}
        onCancel={() => toggleModalDetail(false)}
        width={700}>
        <p>Detail Cek Harga</p>
        <RowForm>
          <Col span={8}>Nama User</Col>
          <Col span={16}>: {priceCheck.User ? priceCheck.User.name : null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>NRP</Col>
          <Col span={16}>: {priceCheck.User ? priceCheck.User.nrp : null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Cabang</Col>
          <Col span={16}>: {priceCheck.branch}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Area</Col>
          <Col span={16}>: {priceCheck.area}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Merk</Col>
          <Col span={16}>: {priceCheck.merk}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Seri</Col>
          <Col span={16}>: {priceCheck.seri}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Silinder</Col>
          <Col span={16}>: {priceCheck.silinder}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Tipe</Col>
          <Col span={16}>: {priceCheck.tipe}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Transmisi</Col>
          <Col span={16}>: {priceCheck.transmisi}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Tahun</Col>
          <Col span={16}>: {priceCheck.tahun}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Bahan Bakar</Col>
          <Col span={16}>: {priceCheck.bahanBakar}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Provinsi</Col>
          <Col span={16}>: {priceCheck.provinsi}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Penggerak</Col>
          <Col span={16}>: {priceCheck.penggerak}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Hari / Tanggal Cek Harga</Col>
          <Col span={16}>
            :{" "}
            {momentTZ(priceCheck.createdAt)
              .tz("Asia/Jakarta")
              .format("dddd, D MMMM YYYY HH:mm")}
          </Col>
        </RowForm>
      </Modal>
    ) : null;
  }
}

export default ModalDetail;



// WEBPACK FOOTER //
// src/components/Dashboard/MobbiPriceCheckHistory/ModalDetail.js